import script from "./data-tag.vue?vue&type=script&setup=true&lang=ts"
export * from "./data-tag.vue?vue&type=script&setup=true&lang=ts"

import "./data-tag.vue?vue&type=style&index=0&id=7d42e2b0&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d42e2b0"]])

export default __exports__